module.exports = __webpack_public_path__ + "img/study.2209dbef.jpg";